export const DEFAULT_SORT_FIELD = 'Id';

export const SORT_DIRECTION = 'sortDirection';
export const SORT_BY = 'sortBy';
